import { Row, SmartTooltip, Text } from '~/commonComponents';
import InfoIcon from '~/images/icons/Info';
import { Colors } from '~/themes/colors';

export const Title = () => (
  <Row>
    <Text bold fontSize={18}>
      Invite:&nbsp;
      <Text color={Colors.neutral_500}>(Optional)</Text>
    </Text>
    <SmartTooltip
      content="Please note, invites will not be delivered to candidates on requested dates in which they are unavailable."
      position="bottom"
    >
      <InfoIcon color={Colors.neutral_300} />
    </SmartTooltip>
  </Row>
);
